module.exports = __webpack_public_path__ + "img/auth4.961c128d.png";